module.exports = __webpack_public_path__ + "assets/img/74@3x.b09afeaf.png";